import type { TFunction } from 'i18next'

export enum EnergyTypeEnum {
  DEFAULT = 'default',
  ELECTRICITY = 'electricity',
  PRESSURIZED_AIR = 'pressurizedAir',
  GAS = 'gas',
  WATER = 'water',
  HEATING = 'heating',
  FUELS = 'fuels',
  FLUID_GAS = 'fluidGas',
}

export const ENERGY_TYPE_ID_BY_TITLE: Partial<Record<EnergyTypeEnum, number>> = {
  [EnergyTypeEnum.FUELS]: 3,
  [EnergyTypeEnum.FLUID_GAS]: 4,
  [EnergyTypeEnum.WATER]: 5,
  [EnergyTypeEnum.HEATING]: 6,
  [EnergyTypeEnum.ELECTRICITY]: 7,
  [EnergyTypeEnum.GAS]: 8,
  [EnergyTypeEnum.PRESSURIZED_AIR]: 9,
}

export const ENERGY_TYPE_ICON_NAMES = {
  [EnergyTypeEnum.ELECTRICITY]: 'electricity',
  [EnergyTypeEnum.GAS]: 'gas',
  [EnergyTypeEnum.WATER]: 'water',
  [EnergyTypeEnum.HEATING]: 'heating',
  [EnergyTypeEnum.PRESSURIZED_AIR]: 'pressurizedAir',
  [EnergyTypeEnum.FUELS]: 'fuels',
  [EnergyTypeEnum.FLUID_GAS]: 'fluidGas',
} as const satisfies Partial<Record<EnergyTypeEnum, string>>

export const hasEnergyTypeIcon = (energyType?: string | null): energyType is keyof typeof ENERGY_TYPE_ICON_NAMES =>
  !!energyType && energyType in ENERGY_TYPE_ICON_NAMES

export const getEnergyTypeLabel = (energyType?: string | null, t?: TFunction): string => {
  const energyTypeValue = (energyType ?? '').toString().trim()
  if (!energyTypeValue) return ''

  if (!t) return energyTypeValue

  switch (energyTypeValue) {
    case EnergyTypeEnum.ELECTRICITY:
      return t('energyType.electricity') as string
    case EnergyTypeEnum.PRESSURIZED_AIR:
      return t('energyType.pressurizedAir') as string
    case EnergyTypeEnum.GAS:
      return t('energyType.gas') as string
    case EnergyTypeEnum.WATER:
      return t('energyType.water') as string
    case EnergyTypeEnum.HEATING:
      return t('energyType.heating') as string
    case EnergyTypeEnum.FUELS:
      return t('energyType.fuels') as string
    case EnergyTypeEnum.FLUID_GAS:
      return t('energyType.fluidGas') as string
    default:
      return energyTypeValue
  }
}
